import { ADD_APOLLO_ERROR, CLEAR_APOLLO_ERROR } from './ApolloErrorActions';

const initialState = {
  apolloError: null,
};

const ApolloErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_APOLLO_ERROR:
      return {
        ...state,
        apolloError: action.apolloError,
      };

    case CLEAR_APOLLO_ERROR:
      return {
        ...state,
        apolloError: null,
      };

    default:
      return state;
  }
};

export default ApolloErrorReducer;
